import { addDays, endOfWeek, format, startOfWeek } from 'date-fns'
import type { MetricsDataPoint } from '~/types/wpnStore'

export function aggregateWeeklyData(
  history: MetricsDataPoint[],
  locale: string,
  isV2: boolean = false,
) {
  // Fill in empty data between last historical date to today with 0s
  const completeHistory = [...history]
  let lastDate = completeHistory.at(-1)?.date
  const today = new Date()
  while (lastDate !== format(today, 'yyyy-MM-dd')) {
    if (!lastDate) break

    lastDate = format(addDays(formatRawDate(lastDate), 1), 'yyyy-MM-dd')
    completeHistory.push({ date: lastDate, value: 0 })
  }

  const map = completeHistory.reduce(
    (acc, curr) => {
      const { date, value } = curr

      if (value !== 0 && !value) return acc

      const formattedDate = formatRawDate(date)

      const start = startOfWeek(formattedDate, { weekStartsOn: 1 }) // start weeks on monday
      const end = endOfWeek(formattedDate, { weekStartsOn: 1 })

      const startMonth = formatLocalizedDate(
        start.toISOString(),
        'MMM',
        locale,
      ).toUpperCase()
      const startDay = formatLocalizedDate(start.toISOString(), 'd', locale)
      const endMonth = formatLocalizedDate(
        end.toISOString(),
        'MMM',
        locale,
      ).toUpperCase()
      const endDay = formatLocalizedDate(end.toISOString(), 'd', locale)

      let label = ''
      if (startMonth === endMonth) {
        label = `${startMonth} ${startDay}-${endDay}`
      } else {
        label = `${startMonth} ${startDay}-${endMonth} ${endDay}`
      }

      if (!acc[label]) {
        acc[label] = { label, value }
      } else {
        if (isV2) {
          // Don't overwrite a real rolling-count value with a backfilled 0
          // on partial weeks (backfill fills post-last-date with 0s)
          if (value !== 0) acc[label].value = value
        } else {
          acc[label].value += value
        }
      }

      return acc
    },
    {} as { [key: string]: { label: string; value: number } },
  )

  return map
}
